module.exports = __webpack_public_path__ + "media/images/gallery/10-fca060ec1e21ad1e473ee1e0c4e06848.jpg";